export const EXPENSE_METHODS = ['CASH', 'BANK_TRANSFER', 'CARD'] as const;
export type ExpenseMethod = (typeof EXPENSE_METHODS)[number];

export const RECURRING_EXPENSE_FREQUENCIES = ['MONTHLY', 'YEARLY'] as const;
export type RecurringExpenseFrequency = (typeof RECURRING_EXPENSE_FREQUENCIES)[number];
